import { AnalyticsBrowser } from "@segment/analytics-next"

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    analytics: any
  }
}

export const analytics = new AnalyticsBrowser()
